// extracted by mini-css-extract-plugin
export var divider = "_hi-0";
export var systemMessage = "_hi-1";
export var systemMessageWrapper = "_hi-2";